import React from "react";
import ListView from "../Common/Views/ListView";

const EmployeesList = ({
    filters = {},
    addButton = true,
    onSelect = null, // a function to override the table row click action (default is to navigate to details page)

    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
}) => {

    // Columns configuration for rendering items list
    const columnsConfig = {
        name: {
            key: 'name',
            label: 'Name',
            render: row => row.name
        },
        phoneNumber: {
            key: 'phoneNumber',
            label: 'Phone number',
            render: row => row.phoneNumber
        },
        status: {
            key: 'status',
            label: 'Status',
            render: row => {
                const statusLabels = {
                    'ACTIVE': 'Active',
                    'INACTIVE': 'Inactive',
                    'TERMINATED': 'Terminated'
                };
                return statusLabels[row.status] || row.status;
            }
        },
    };


    return <ListView
        title="Employees"
        apiPath="/tenants/employees"
        filters={filters}
        addButton={addButton}
        addButtonLabel="Add new employee"
        addPath="/employees/add"
        rowClickPath={(employee) => `/employees/${employee.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        searchBox={true}
        searchAttributes={[
            { name: 'name', label: 'Name', type: 'text' },
            { name: 'phoneNumber', label: 'Phone number', type: 'text' },
            { name: 'status', label: 'Status', type: 'select', options: [
                { value: '', label: 'All' },
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
            ]},
        ]}
        noResultsMessage="No employees found"
    />
};

export default EmployeesList;
